kombi.toggleReadMore = {
    init: function(context) {
        const searchContext = context || document;
        const mobileLimit = 70;
        const desktopLimit = 294;
        const limit = window.innerWidth < 576 ? mobileLimit : desktopLimit;

        searchContext.querySelectorAll('.text-preview').forEach(function(textPreview) {
            const id = textPreview.getAttribute('data-id');
            const fullText = textPreview.getAttribute('data-full-text') || textPreview.textContent.trim();
            const toggleLink = document.querySelector('.toggle-read-more[data-id="' + id + '"]');

            if (!toggleLink) return;

            if (fullText.length > limit && !textPreview.getAttribute('data-full-text')) {
                textPreview.setAttribute('data-full-text', fullText);
                textPreview.textContent = fullText.substr(0, limit) + '...';
                toggleLink.classList.remove('d-none');
            } else if (fullText.length <= limit) {
                toggleLink.classList.add('d-none');
            }
        });
    },

    click: function (toggleLink) {
        const mobileLimit = 70;
        const desktopLimit = 294;
        const limit = window.innerWidth < 576 ? mobileLimit : desktopLimit;
        
        const id = toggleLink.getAttribute('data-id');
        const wrapper = toggleLink.closest('.room-description-wrapper');
        if (!wrapper) {
            console.error("Erro: container '.room-description-wrapper' não encontrado.");
            return;
        }

        const textPreview = wrapper.querySelector('.preview-' + id);

        if (!textPreview) return;

        const fullText = textPreview.getAttribute('data-full-text');
        const isLimited = textPreview.classList.contains('limited');

        if (isLimited) {
            textPreview.textContent = fullText;
            textPreview.classList.remove('limited');
            toggleLink.textContent = 'Ver menos';
        } else {
            textPreview.textContent = fullText.substr(0, limit) + (fullText.length > limit ? '...' : '');
            textPreview.classList.add('limited');
            toggleLink.textContent = 'Ver mais';
        }
    }
};
kombi.readMore = function (root) {
    const scope = root && root.querySelectorAll ? root : document;
    const defaultMobileVisibleLimit = 5;
    const defaultDesktopVisibleLimit = 7;

    function getVisibleLimit(wrapper) {
        const mobileLimit = parseInt(wrapper.dataset.limitMobile, 10);
        const desktopLimit = parseInt(wrapper.dataset.limitDesktop, 10);
        const mobile = Number.isFinite(mobileLimit) ? mobileLimit : defaultMobileVisibleLimit;
        const desktop = Number.isFinite(desktopLimit) ? desktopLimit : defaultDesktopVisibleLimit;
        return window.innerWidth < 576 ? mobile : desktop;
    }

    scope.querySelectorAll('.amenities-wrapper').forEach(function(wrapper) {
        const visibleLimit = getVisibleLimit(wrapper);
        const items = wrapper.querySelectorAll('.amenity-item:not(.see-more-wrapper)');
        const btnWrappers = wrapper.querySelectorAll('.see-more-wrapper');

        if (items.length <= visibleLimit) {
            btnWrappers.forEach(function (w) {
                w.remove();
            });
            return;
        }

        const btnWrapper = btnWrappers[0];
        if (!btnWrapper) return;

        const btn = btnWrapper.querySelector('.see-more-btn');
        if (!btn) return;

        if (btn.getAttribute('data-bs-toggle') === 'modal') {
            const mobileWrapper = wrapper.querySelector(
                '.see-more-wrapper:not(.see-more-wrapper--desktop)'
            );
            const desktopWrapper = wrapper.querySelector('.see-more-wrapper--desktop');
            const activeWrapper =
                window.innerWidth < 576 ? mobileWrapper : desktopWrapper || mobileWrapper;

            btnWrappers.forEach(function (w) {
                if (w !== activeWrapper) {
                    w.classList.add('d-none');
                    w.classList.remove('d-flex', 'd-sm-flex', 'd-sm-none');
                }
            });

            if (!activeWrapper) return;

            items.forEach((item, index) => {
                if (index >= visibleLimit) {
                    item.classList.add('d-none');
                }
            });

            const itemAfterLimit = items[visibleLimit];
            if (itemAfterLimit) {
                itemAfterLimit.before(activeWrapper);
            }
            activeWrapper.classList.remove('d-none');
            activeWrapper.classList.add('d-flex');
            if (desktopWrapper && activeWrapper === desktopWrapper) {
                activeWrapper.classList.remove('d-sm-none');
            }
            return;
        }

        const itemAfterLimit = items[visibleLimit];

        if (itemAfterLimit) {
            itemAfterLimit.before(btnWrapper);
        }
        btnWrapper.classList.remove('d-none');
        if (btn.dataset.readMoreInitialized) return;

        btn.textContent = 'Ver mais';
        btn.setAttribute('aria-expanded', 'false');

        items.forEach((item, index) => {
            if (index >= visibleLimit) {
                item.classList.add('d-none');
            }
        });

        btn.addEventListener('click', function(event) {
            event.preventDefault();
            const isExpanded = btn.getAttribute('aria-expanded') === 'true';
            const currentLimit = getVisibleLimit(wrapper);

            if (!isExpanded) {
                items.forEach(item => item.classList.remove('d-none'));
                wrapper.append(btnWrapper);
                btn.textContent = 'Ver menos';
                btn.setAttribute('aria-expanded', 'true');
            } else {
                items.forEach((item, index) => {
                    if (index >= currentLimit) {
                        item.classList.add('d-none');
                    }
                });
                
                const itemToPlaceBefore = items[currentLimit];
                if (itemToPlaceBefore) {
                    itemToPlaceBefore.before(btnWrapper);
                }
                btn.textContent = 'Ver mais';
                btn.setAttribute('aria-expanded', 'false');
            }
        });

        btn.dataset.readMoreInitialized = 'true';
    });
};
